import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOservicoNaUnidade = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)
    const tipo = useSelector((state) => state.addForm.modulos.tipo)
    
    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    {tipo !== "Caps" && (
                        <>
                            <HeaderVerde texto="SERVIÇOS NA UNIDADE" />
                            <div style={{ textAlign: "left" }}>
                                <Select label="Serviço na Unidade - ILPIS" nome="toservicoilpis" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="13vw" widthMobile="80vw" marginR="2vw"
                                    array={["Sim", "Não", "Não se aplica"]} />
                            </div>
                        </>
                    )}
                    {RenderCondicional()}
                    <HeaderVerde texto="EQUIPE TÉCNICA NA ASSISTÊNCIA" />
                    <CheckContainer>
                        <CheckBox texto="Médico" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="7vw" />
                        <CheckBox texto="Médico Clínico" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="7vw" />
                        <CheckBox texto="Psiquiatra" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="7vw" />
                        <CheckBox texto="Psicólogo" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fonoaudiólogo" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Técnico de Enfermagem" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Terapeuta Ocupacional" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Profissional da Educação física" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Assistente Social" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Enfermeiro" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Fisioterapeuta" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Nutricionista" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Outro profissional" grupo="tosetoresilpis" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>
                </Caixa>
            )
            function RenderCondicional() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["toservicoilpis"]
                if (array[modulo][n]["toservicoilpis"] === "Sim") {
                    campos.push(
                        <>
                            <div style={{ textAlign: "left" }}>
                                <HeaderVerde texto="Institucionalizados" />
                                <Input label="Capacidade Máxima" nome="tocapacidade" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                                <Input label="Número de Institucionalizados" nome="toinstitucionalizados" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />

                                <HeaderVerde texto="Quantitativo" />
                                <Input label="Masculino" nome="tomasculino" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                                <Input label="Feminino" nome="tofeminino" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                                <Input label="Não Idosos" nome="toidosos" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                                <Input label="Acamados" nome="toacamados" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                                <Input label="Cadeirantes" nome="tocadeirantes" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                                <Input label="Amputados" nome="toamputados" modulo={modulo} index={n}
                                    componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                            </div>
                            <HeaderVerde texto="GRAU DE DEPENDÊNCIA DOS INSTITUCIONALIZADOS" />
                            <div style={{ textAlign: "left" }}>
                                <Input label="Grau I - Idosos Independentes" nome="tograuI" modulo={modulo} index={n}
                                    componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                                <Input label="Grau II - Idosos com Dependência em até Três Atividades de Autocuidado" nome="tograuII" modulo={modulo} index={n}
                                    componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                                <Input label="Grau III - Idosos Totalmente Dependentes" nome="tograuIII" modulo={modulo} index={n}
                                    componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                            </div>
                            <HeaderVerde texto="ATIVIDADES DA INSTITUIÇÃO" />
                            <div style={{ textAlign: "left" }}>
                                <Select label="Atividade Física, Recreativa ou Cultural" nome="toatividadelazer" modulo={modulo} index={n}
                                    widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não"]} />
                                <Select label="Atividades na Comunidade Local" nome="tocomunidade" modulo={modulo} index={n}
                                    widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não"]} />
                                <Select label="Atividades Conjuntas com Pessoas de Outras Gerações" nome="toatividadeconjunta" modulo={modulo} index={n}
                                    widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não"]} />
                                <Select label="Participação da Família no Cuidado" nome="tofamilia" modulo={modulo} index={n}
                                    widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não"]} />
                                <Select label="Participação da Comunidade no Cuidado" nome="tocomunidade" modulo={modulo} index={n}
                                    widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não"]} />
                                <Select label="Outras Atividades" nome="tooutrasatividades" modulo={modulo} index={n}
                                    widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não"]} />
                            </div>
                        </>
                    )
                }

                return campos
            }
        }
        return partes
    }
}
export default TOservicoNaUnidade